import React from 'react';
function isTruthyParam(v: string | null) {
    if (!v) return false;
    const normalized = v.toLowerCase();
    return normalized === 'true' || normalized === '1' || normalized === 'yes';
}

const RedirectionPage = (): JSX.Element => {
    React.useEffect(() => {
      const params = new URLSearchParams(window.location.search);
      const success =
          isTruthyParam(params.get('success')) ||
          isTruthyParam(params.get('is_success')) ||
          isTruthyParam(params.get('isSuccess'));

      const kind = params.get('kind'); // Booking | Voucher | Order
      const orderId = params.get('orderId');
      const productId = params.get('productId');
      const bookingId = params.get('bookingId');
      const salonId = params.get('salonId');
      const voucherId = params.get('voucherId');

      let target = '/';
      if (success) {
        if (kind === 'Order' && orderId && productId) target = `/order/${orderId}/${productId}`;
        else if (kind === 'Booking' && bookingId) target = `/booking/${bookingId}`;
        else if (kind === 'Voucher' && voucherId) target = `/voucher/${voucherId}`;
        else if (kind === 'Voucher') target = `/salon/${salonId}`;
        else target = '/';
      } else {
        if (kind === 'Order') target = '/shop';
        else if (kind === 'Booking') target = `/appointment-booking/${salonId}`;
        else if (kind === 'Voucher') target = `/salon/${salonId}`;
        else target = '/';
      }

      window.location.replace(target);
    }, []);


    return (
        <div>Loading...</div>
    )
}

export default RedirectionPage;
